export default __webpack_public_path__ + "static/media/ownership_structure_01.f796d09c.png";